<template>
  <main class="l-main p-register set">
    <div class="l-block">
      <SetLocalNav :hasProject="hasProject" />
      <TitleRegister />
      <div class="l-block__content">
        <div class="hTitle">
          <h1>Google Search Console連携エラー</h1>
        </div>
        <Advice img="error" priority="low-gray">
          <ul class="c-list--disc">
            <li>
              連携しようとしているGoogleアカウントにGoogle Search
              Consoleの権限がない可能性があります。GoogleアカウントにGoogle
              Search Consoleでプロパティの権限があるか確認してください
            </li>
            <li>
              Google Search
              ConsoleのプロパティがURLプレフィックスで作成されていない可能性があります。プロパティを確認してください。<a
                href="https://support.searchwrite.jp/hc/ja/articles/360004328956"
                target="_blank"
                class="c-link--blank"
                >詳しくはこちら</a
              >
            </li>
            <li>
              連携しようとしているGoogleアカウントでSEARCH
              WRITEが許可されていない可能性があります
            </li>
          </ul>
        </Advice>
        <div class="btnArea">
          <div class="form-auto">
            <Button
              variant="border"
              size="w260"
              fsize="f16"
              icon="return_gn"
              :to="{ name: 'setGSC' }"
            >
              戻る
            </Button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Advice from '@/components/Advice';
import Button from '@/components/Button';
import SetLocalNav from '@/components/set/SetLocalNav';
import TitleRegister from '@/components/TitleRegister';

export default {
  components: {
    Advice,
    Button,
    SetLocalNav,
    TitleRegister
  },
  computed: {
    hasProject() {
      return this.$store.getters['user/hasProject'];
    }
  }
};
</script>
